const colors = {
	ROUGE: 'ROUGE',
	JAUNE: 'JAUNE',
	VERT: 'VERT',
	BLANC: 'BLANC'
}

export default colors